import { useState } from 'react';
import XCircleFillIcon from '../../../assets/icons/XCircleFill';

const CredentialModal = ({ onClose, credential, paginationState }) => {

    const [copiedField, setCopiedField] = useState(null);
    const handleCopy = (value, field) => {
        if (!value) return;
        
        // Try modern clipboard API first
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value)
                .then(() => {
                    setCopiedField(field);
                    setTimeout(() => setCopiedField(null), 2000);
                })
                .catch(() => {
                    // Fallback to legacy method
                    fallbackCopy(value, field);
                });
        } else {
            // Use fallback method if clipboard API is not available
            fallbackCopy(value, field);
        }
    };

    const fallbackCopy = (value, field) => {
        try {
            // Create a temporary textarea element
            const textarea = document.createElement('textarea');
            textarea.value = value;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            
            setCopiedField(field);
            setTimeout(() => setCopiedField(null), 2000);
        } catch (err) {
            alert('Failed to copy. Please copy manually.');
        }
    };

    const handleCloseModal = () => {
        onClose();
        paginationState.setPagination({
            ...paginationState.pagination,
            pageIndex: 0
        })
    }

    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>New API Credential</h3>
          <button className='close-btn' onClick={handleCloseModal}><XCircleFillIcon size={24} /></button>

          {credential?.name && (
            <div className="field" style={{ marginBottom: '6px' }}>
              <strong>Name:</strong> <span>{credential.name}</span>
            </div>
          )}
          {credential?.description && (
            <div className="field" style={{ marginBottom: '10px' }}>
              <strong>Description:</strong> <span>{credential.description}</span>
            </div>
          )}

          <p className="warning">
            ⚠️ Please copy your API Secret now. You won't be able to see it again!
          </p>

            <div className="field copy-field">
                <strong>API Key:</strong> 
                <span>{credential?.apiKey}</span>
                <button 
                    className="copy-btn" 
                    onClick={() => handleCopy(credential?.apiKey, 'key')}
                >
                    <img src="/copy.png" alt="" />
                </button>
                {copiedField === 'key' && <span className="copy-tooltip">Copied!</span>}
                {copiedField !== 'key' && <span className="copy-tooltip">Copy</span>}
            </div>
            <div className="field copy-field">
                <strong>API Secret:</strong> 
                <span>{credential?.apiSecret?.length > 20 ? credential?.apiSecret.slice(0, 25) + "......" : credential?.apiSecret}</span>
                <button 
                    className="copy-btn" 
                    onClick={() => handleCopy(credential?.apiSecret, 'secret')}
                >
                    <img src="/copy.png" alt="" />
                </button>
                {copiedField === 'secret' && <span className="copy-tooltip">Copied!</span>}
                {copiedField !== 'secret' && <span className="copy-tooltip">Copy</span>}
            </div>
        </div>
      </div>
    );
};

export default CredentialModal;
